import { runOutcome } from "./runs";

/**
 * As etapas do teste de um job, como a tela as mostra (AB#86605): na fila
 * (o pedido saiu e a execução ainda não começou), o agente trabalhando, e o fim.
 */
export type TestStage = "queued" | "working" | "completed" | "failed";

const QUEUED_STATUSES = new Set(["queued", "pending"]);

/** A etapa a partir do que já se sabe: sem execução ainda, ou o status dela. */
export function testStage(status: string | null | undefined): TestStage {
  if (!status || QUEUED_STATUSES.has(status)) return "queued";
  const outcome = runOutcome(status);
  if (outcome === "live") return "working";
  return outcome === "completed" ? "completed" : "failed";
}

/** Quanto do trabalho do agente a barra mostra com 2 minutos: a metade do trecho dele. */
const WORKING_HALF_LIFE_MS = 120_000;

/**
 * O preenchimento da barra, de 0 a 100.
 *
 * O agente não diz quanto falta, então a barra não finge saber: na fila ela
 * fica no começo, e enquanto o agente trabalha ela avança cada vez mais devagar
 * — se aproxima de 90% sem nunca chegar —, para mostrar que algo acontece sem
 * prometer um fim. O fim, bom ou ruim, é sempre 100%.
 */
export function testProgress(stage: TestStage, workingForMs: number): number {
  if (stage === "completed" || stage === "failed") return 100;
  if (stage === "queued") return 8;
  const elapsed = Math.max(workingForMs, 0);
  return Math.round(15 + 75 * (1 - Math.pow(0.5, elapsed / WORKING_HALF_LIFE_MS)));
}

/** O cronômetro do teste: `0:42`, `3:05`, `1:02:10`. */
export function formatElapsed(ms: number): string {
  const total = Math.max(Math.floor(ms / 1000), 0);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = String(total % 60).padStart(2, "0");
  return hours > 0 ? `${hours}:${String(minutes).padStart(2, "0")}:${seconds}` : `${minutes}:${seconds}`;
}
